import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

/** Component scrolling page up. */
const ScrollToTop = ({ history }): null => {
  useEffect(() => {
    const unsubscribe = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return (): void => {
      unsubscribe();
    };
  }, [history]);

  return null;
};

export default withRouter(ScrollToTop);
